import { Scene } from "phaser";
import { Constants } from "@core/Utils/Constants";
import { MenuButton } from "@core/GUI/MenuElements/MenuButton";
import { Client } from "@core/Client";

export class MenuDialog extends Phaser.GameObjects.Container {

    public buttons: Array<MenuButton> = new Array<MenuButton>();

    private ninePatch: RexPlugins.GameObjects.NinePatch;

    constructor(public scene: Scene, x: number, y: number, width: number, height: number) {
        super(scene, x, y);
        this.ninePatch = new RexPlugins.GameObjects.NinePatch(scene, 0, 0, width, height, Constants.SPRITESHEET_MENU, "MenuBackground.png", [16, undefined, 16], [16, undefined, 16], { edge: 'scale', internal: 'scale' });
        this.ninePatch.setOrigin(0);
        this.ninePatch.setInteractive(new Phaser.Geom.Rectangle(-width, -height, width * 2, height * 2), Phaser.Geom.Rectangle.Contains)
            .on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.blockAndClose, this)
            .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.blockInput, this)
            .on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.blockInput, this)
        this.add(this.ninePatch);
        this.visible = false;
    }

    private blockInput(pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) {
        event.stopPropagation();
    }

    private blockAndClose(pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) {
        setTimeout(function () {
            Client.logic.lockAnimations = this.visible = false;
        }.bind(this), 100);
        event.stopPropagation();
    }

    public addButton(button: MenuButton) {
        this.add(button);
        this.buttons.push(button);
    }

    public ResizeAndMove(x: number, y: number, width: number, singleButtonHeight: number, padding: number, staticWidth: number, staticHeight: number) {
        this.x = x;
        this.y = y;

        let buttonHeightSoFar: number = 0;

        this.buttons.forEach((button, index) => {
            button.ResizeAndMove(padding, padding * (index + 1) + buttonHeightSoFar, width - (2 * padding), singleButtonHeight, padding);
            buttonHeightSoFar += button.height;
        });

        this.ninePatch.setSize(width, buttonHeightSoFar + padding * (this.buttons.length + 1));
        this.ninePatch.input.hitArea.setSize(staticWidth * 2, staticHeight * 2);
        this.ninePatch.input.hitArea.setPosition(-staticWidth, -staticHeight);
        this.setSize(width, buttonHeightSoFar);
    }

    override setVisible(value: boolean): this {
        super.setVisible(value);
        Client.logic.lockAnimations = value;
        return this;
    }
}